var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-waiting-modal-mobile-component" }, [
    _c("div", { staticClass: "room-waiting-modal-mobile" }, [
      _c("div", { staticClass: "room-waiting-modal-mobile-header" }, [
        _c("button", {
          staticClass: "room-waiting-modal-mobile-btn back",
          on: { click: _vm.onClose },
        }),
        _c("div", { staticClass: "room-waiting-modal-mobile-title" }, [
          _vm._v(_vm._s(_vm.$t("waitingRoom.list.title"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "room-waiting-modal-mobile-body" },
        [_c("RoomWaitingList")],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }